import { formValueSelector } from 'redux-form/immutable';
import moment from 'moment';

import { State } from 'reducers';

export const INIT = 'app/CampaignPage/INIT';
export const INIT_SUCCESS = 'app/CampaignPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CampaignPage/INIT_FAILED';
export const LOAD_FORM = 'app/CampaignPage/LOAD_FORM';

export const CAMPAIGN_PAGE_FORM = 'app/CampaignPageForm';
export const SAVE = 'app/CampaignPageForm/SAVE';
export const SAVE_SUCCESS = 'app/CampaignPageForm/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/CampaignPageForm/SAVE_FAILED';

interface InitAction {
  type: typeof INIT;
}
interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}
interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: any;
  errorCode?: number;
}

type CampaignPageAction = InitAction | InitSuccessAction | InitFailedAction;

const initAction = (id: string, duplicate: boolean, campaignType?: CampaignFormType) => ({
  type: INIT,
  id,
  campaignType,
  duplicate,
});
const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
const initFailedAction = (error: any, errorCode?: any) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data: any) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (form: any) => ({
  type: SAVE_SUCCESS,
  form,
});
export const saveFailedAction = (error: any, errorCode: any, additional?: any) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export enum CampaignFormType {
  GivingPledge = 'pledge',
  Campaign = 'campaign',
}

export type FormData = {
  backgroundImage?: string;
  privacy: unknown;
  nonprofits: {
    id: string;
    externalId?: string;
    nonprofitId?: string;
  }[];
  pledgedDonationStartingAt?: moment.Moment;
  pledgedDonationEndingAt?: moment.Moment;
  allowOneTimePledge: boolean;
  contentSortingSections: unknown;
  startingAt: moment.Moment;
  volunteering: unknown[];
  fundraisers: unknown[];
  events: unknown[];

  sorting: unknown;

  colorA: string;
  colorB: string;
  nameColor: string;
  ctaButtonColor: string;
  ctaTextColor: string;
  backgroundHeroColor: string;
  backgroundDeedsColor: string;
};

export const valueSelector: <K extends keyof FormData>(state: State, key: K) => FormData[K] =
  formValueSelector(CAMPAIGN_PAGE_FORM);

export {
  InitAction,
  InitSuccessAction,
  InitFailedAction,
  initAction,
  initSuccessAction,
  initFailedAction,
  CampaignPageAction,
};
